
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';

  @Component({
    components: {},
  })
  export default class DlgGuestSelector extends Vue {
    @Prop({type: Boolean, default: false}) private loading!: boolean;
    @Prop({type: Array, default: () => []}) private existingGuests!: any;

    @Action('user/guests/read') private read!: any;

    @Getter('user/guests/all') private all!: any;

    private search: string = '';
    private headers: any = [
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
        width: '50px',
      },
      {
        text: 'Vorname',
        align: 'left',
        value: 'forename',
      },
      {
        text: 'Nachname',
        align: 'left',
        value: 'surname',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
    ];
    private dialog: boolean = false;
    private localGuests: any = [];

    public close() {
      this.dialog = false;
    }

    private async mounted() {
      if (!this.all || this.all.length === 0) {
        await this.read();
      }
    }

    private addList(guest) {
      this.$emit('selected', guest);
    }

    @Watch('dialog')
    private dialogChanged() {
      if (this.dialog) {
        const ids = this.existingGuests.map((el) => el.id);
        this.localGuests = this.all.filter((guest) => ids.indexOf(guest.id) === -1);
      }
    }
  }
